module.exports = __webpack_public_path__ + "img/album16_05.2494f11d.jpg";